<mat-dialog-content>
  <lemon-dialog-header> Haluatko varmasti poistaa kirjauksen? </lemon-dialog-header>

  <div style="text-align: center">Kirjaus merkitään poistetuksi. Toimintoa ei voi perua.</div>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 0; padding-right: 0">
  <app-secondary-button [focusRegionStart]="true" mat-dialog-close actionId="Peruuta (poista kirjaus dialog)">Peruuta</app-secondary-button>
  <span style="display: inline-block; width: 8vw; max-width: 4em"></span>
  <app-primary-button (click)="poista()" actionId="Kirjaus poistettiin">Poista</app-primary-button>
</mat-dialog-actions>
